/*
 * Copyright(c) 2021 architectural award, All Rights Reserved.
 * Author: lxj
 */
import fetch from '@/utils/fetch';

export default {
  updateAccountStatus: data => {
    return fetch({
      url: 'accounts/check-status',
      method: 'put',
      data
    })
  }
}